import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { isMainDomain } from '../../contexts/ThemeContext';
import { Landing_1 } from './Landing_1';

export function StealthGuard() {
  const { pathname } = useLocation();

  // Only show landing page on main domain root
  if (isMainDomain() && pathname === '/') {
    return <Landing_1 />;
  }

  // Everything else passes through
  return <Outlet />;
}
